import { Component, Inject } from '@angular/core';

import { PlaceholderService
       } from 'collage-designer/stage/placeholder/placeholder.service';
import { Utils } from '../../core/utils';
import { ToolboxComponent } from '../toolbox.component';
import { ToolboxService } from '../toolbox.service';

@Component({
    selector: 'image-edit-toolbox',
    templateUrl: './image-edit-toolbox.component.html',
    styleUrls: [
        '../toolbox.component.scss', './image-edit-toolbox.component.scss'],
    standalone: false
})
export class ImageEditToolboxComponent extends ToolboxComponent
{
  protected name: string = 'ImageEditToolbox';

  constructor(
      @Inject(ToolboxService) toolboxService,
      @Inject(PlaceholderService) private placeholderService)
  {
    super(toolboxService);
  }

  public async resetPlaceholder(): Promise<void>
  {
    await this.placeholderService.getFocusedPlaceholder().reset();
  }

  public get isMobileDevice(): boolean
  {
    return !Utils.isLargeDevice();
  }

  public btnCloseClick(): void
  {
    this.placeholderService.setFocusedPlaceholder(undefined);
  }
}
